<template>
    <div :class="`border-left ${validationClass}`">
        <b-form-group class="ml-2" :state="isValid" :invalid-feedback="$t('nBox.form.validations.variablesRequired')">
            <div class="text-muted font-weight-bold mb-1">
                {{ $t('nBox.form.addSomeVariable') }}
            </div>
            <b-button
                :key="i"
                size="sm"
                class="mr-2"
                variant="primary mb-1"
                v-for="(variable, i) in variables"
                @click="removeVariable(i)"
            >
                <img width="20" height="20" :src="modules[variable.module].image" />
                <span class="font-weight-bold"> {{ modules[variable.module].title }}</span>
            </b-button>
            <b-dropdown no-caret size="sm" :variant="dropDownVariant">
                <template slot="button-content">
                    <i class="fas fa-plus mr-2" />
                    <span class="font-weight-bold">{{ $t('form.button.add') }}</span>
                </template>
                <b-dropdown-item @click="addVariable('values', 'evaluations_results')">{{
                    modules.values.title
                }}</b-dropdown-item>
                <b-dropdown-item @click="addVariable('target')">{{ modules.target.title }}</b-dropdown-item>
            </b-dropdown>
        </b-form-group>
    </div>
</template>
<script>
import i18n from '@/i18n'
export default {
    props: {
        axis: {
            type: String,
            required: true,
        },
        variables: {
            type: Array,
            required: true,
        },
        isValid: {
            type: Boolean,
            default: null,
        },
    },
    methods: {
        addVariable(module, result_type = null) {
            const items = [
                ...this.variables,
                {
                    id: Math.random(),
                    module,
                    result_type,
                    axis: this.axis,
                    category_id: null,
                    team_weight: 0,
                    unit_weight: 0,
                    personal_weight: 0,
                    result_weight: this.variables.length == 0 ? 100 : 0,
                },
            ]
            this.$emit('update', items)
        },
        removeVariable(index) {
            const items = this.variables.filter((_, itemIndex) => index != itemIndex)
            this.$emit('update', items)
        },
    },
    computed: {
        validationClass() {
            return this.isValid === false ? 'invalid' : ''
        },
        dropDownVariant() {
            return this.isValid === false ? 'outline-danger' : 'link'
        },
        modules() {
            return {
                target: {
                    title: i18n.t('targets.targets'),
                    image: require('@/assets/icons/target_white.svg'),
                },
                values: {
                    title: i18n.t('nBox.values'),
                    image: require('@/assets/icons/values_white.svg'),
                },
            }
        },
    },
}
</script>
<style scoped lang="sass">
::v-deep .btn-outline-danger
    border: none !important
</style>
